/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import clsx from 'clsx';

import { Eyebrow, Heading, IconBlock, Types } from '@marriott/mi-ui-library';
import { isMarriottInternalUrl } from '../../utils/CommonUtils';

import { OffersBenefitCardsProps } from './OffersBenefitCards.types';
import { StyledOffersBenefitCards } from './OffersBenefitCards.styles';

export const OffersBenefitCardsWrapper: FC<OffersBenefitCardsProps> = props => {
  const benifitsCardData = props?.offersData?.responseObject?.offers?.[0]?.merchandisingOffer?.singleCard?.highlight;
  const trackingProperties = props?.model?.trackingProperties;

  const hasContent =
    benifitsCardData?.eyebrow ||
    benifitsCardData?.title ||
    benifitsCardData?.cards?.some((card: any) => card?.title || card?.description);

  if (!hasContent) {
    return null;
  }

  return (
    <StyledOffersBenefitCards
      data-testid="offers-benefitsCard"
      data-component-name="o-offers-BenefitsCard"
      className={props?.model?.styleclass ?? ''}
    >
      <div className="benefitcard-container">
        <div className="benefitcard-wrapper">
          {benifitsCardData?.eyebrow && (
            <Eyebrow text={benifitsCardData?.eyebrow} customClass={clsx('mb-2 text-center')} />
          )}
          {benifitsCardData?.title && (
            <Heading
              titleText={benifitsCardData?.title}
              variation={Types.headingType.title}
              fontSize={Types.size.medium}
              customClass={'benefitcard-title text-center mb-0'}
            />
          )}
          <div className="benefitcard-outer">
            {benifitsCardData?.cards?.length > 0 &&
              benifitsCardData?.cards?.map((card: any) => {
                const isInternal = isMarriottInternalUrl(card?.ctaLink);
                return (
                  card?.title !== null &&
                  card?.title !== undefined &&
                  card?.title?.length > 0 && (
                    <div className="card-grid">
                      <IconBlock
                        ctaLink={card?.ctaLink ?? ''}
                        ctaType="tertiaryLink"
                        variation=""
                        contentAlignment="left"
                        assetVariation="iconfont"
                        iconPath={card?.icon}
                        iconType="iconDecorative"
                        ctaLinkText={card?.ctaLabel}
                        descriptionText={card?.description}
                        header={card?.title}
                        headerFontSize={'t-subtitle-l'}
                        openInNewTab={!isInternal}
                        trackingProperties={{
                          ...trackingProperties,
                          trackingDescription: `${card?.ctaLabel} - ${card?.title}`,
                        }}
                      />
                    </div>
                  )
                );
              })}
          </div>
        </div>
      </div>
    </StyledOffersBenefitCards>
  );
};
